import ProfilePage from './Profile'

const Profile = () => (
        <ProfilePage/>
)

export default Profile
